import React, {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react';

import { INITIAL_MODAL_STATE } from '@constants/common/modals.constants';

import { ModalsState, ShowModal } from '@app-types/common/modal.types';

interface UseModals {
  state: ModalsState;
}

const initialContextState = {
  state: INITIAL_MODAL_STATE,
};

interface modalsActionsType {
  show: ShowModal;
  hide: () => void;
}

export let modalActions: modalsActionsType;

const ModalContext = createContext<UseModals>(initialContextState);

export const useModals = (): UseModals => useContext(ModalContext);

const ModalsProvider: FC<PropsWithChildren> = ({ children }) => {
  const [state, setState] = useState<ModalsState>(INITIAL_MODAL_STATE);

  modalActions = {
    show: (current, props) => {
      setState({ current, props });
    },
    hide: () => {
      setState(INITIAL_MODAL_STATE);
    },
  };

  return (
    <ModalContext.Provider value={{ state }}>{children}</ModalContext.Provider>
  );
};

export default ModalsProvider;
